import React, {
  useMemo,
  useEffect,
  createContext,
  useContext,
  useCallback,
  useState
} from 'react';
import { newMessage } from 'views/internalChat/socketInternalChat/message-socket';
import notification from 'views/internalChat/components/sound/notificationInternalChat.wav';
import io from 'socket.io-client';
import { useSocketEvents, wrapSocketWithGlobalLoader } from './socket-utils';

const music = new Audio(notification);

const useInternalChatSocket = createContext();

export function SocketInternalChatProvider({ children }) {
  const [soundEnabled, setSoundEnabled] = useState(true);

  const socketInternalChat = useMemo(() => {
    return wrapSocketWithGlobalLoader(
      io.connect(process.env.REACT_APP_PROXY_URL, {
        path: process.env.REACT_APP_INTERNAL_CHAT_SOCKET_PATH,
        transports: ['websocket'],
        upgrade: false
      })
    );
  }, []);

  useEffect(() => {
    return () => {
      socketInternalChat.close();
    };
  }, [socketInternalChat]);

  useEffect(() => {
    socketInternalChat.emit('introduction', {
      identity: localStorage.getItem('login')
    });
  }, [socketInternalChat]);

  const callBack = useCallback(
    (response) => {
      newMessage(response);
      if (soundEnabled && response.sender !== localStorage.getItem('login')) {
        music.play();
      }
    },
    [soundEnabled]
  );

  const groupCallBack = useCallback(
    (response) => {
      if (soundEnabled && response.sender !== localStorage.getItem('login')) {
        music.play();
      }
    },
    [soundEnabled]
  );

  useSocketEvents(socketInternalChat, {
    message: callBack,
    'group:message_receive': groupCallBack
  });

  return (
    <>
      <useInternalChatSocket.Provider
        value={{
          socketInternalChat: socketInternalChat,
          soundEnabled,
          setSoundEnabled
        }}
      >
        {children}
      </useInternalChatSocket.Provider>
    </>
  );
}

export function useConectionSocketChatInternal() {
  const context = useContext(useInternalChatSocket);
  return context;
}
